import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type {
  IMPORT_STATE,
  ImportHistoryItemT,
} from '@/features/Setting/Integrations/providers/types';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';

export type FrontResponse = {
  name: string;
  workspace_id: string;
  state: IMPORT_STATE;
  history?: ImportHistoryItemT[];
  created_at: string;
  created_by: string;
};

const FrontRedirect = () => {
  const [, setRedirect] = useCrossWindowState<FrontResponse | null>(
    'front-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        const data = await services.front.createFrontInfo(
          code,
          workspaceAlias,
          `${window.location.origin}/front`,
        );

        if (data) {
          setRedirect(data);
          window.close();
        } else {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting this front channel...</LoadingLayout>;
};

export default FrontRedirect;
